<template>
<div >
          <div id="UserInfo">
           
          <h2 class="m4u_text--text">{{profile.UserFirst}} {{profile.UserLast}} </h2> 
      <div>
        <v-img :src="profilesas" class=" imageTag" max-width="3rem"></v-img></div>         
      </div> 

    <div id="UserContent">

        <v-tabs
                dark
                background-color="m4u_text"
                show-arrows
              >
      <v-tabs-slider color="primary lighten-3"></v-tabs-slider>

      <v-tab
        v-for="item in items"
        :key="item"
        @click="getContent(item)"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
        </div>  

<!-- START STORY CARDS --->
          <div v-if= "contentType === 1 || contentType===2 || contentType===3 || contentType===4 || contentType==='J'" class="justify-center"
           :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'">

          <div id="storyCard2" v-for="memory in memories" :memory="story" :key="memory.StoryID" >
            <v-layout justify-center>
          <StoryCard :story="memory" id="storyCard3_component" />
          </v-layout>
          </div>

        <!-- empty div for infinite scrolling --->
    <div v-observe-visibility="handleScrolledToBottom"></div>
        </div>    

                            <!-- START BOOK CARDS --->

          <div v-if= "contentType === 'B'">

              <div v-for="book in books" :key="book.BookID" >
              <BookCard :book="book" />
            </div>
    
        </div> 

        </div>

</template>

<script>
import StoryCard from "@/components/StoryCard";
import EventService from '@/services/EventService.js'; 
import BookCard from "@/components/BookCard";

export default {
  name: 'profile',

  components: {
    StoryCard,
    BookCard
  },

 data() {
    return {
      tab: null,
       items: [
          'Memories', 'Recipes', 'Interviews', 'Traditions', 'Books'
        ],
        contentType: 1,
        memories: [],
        recordStart: 0,
        recordLast: '',
        profileID: '',
        isUser: false,
        profileUser: [],
        story: '',
        idialog: false,
        file: '',
        selectedFile: null,
        message: '',
        profilesas: '',
        books: [],
        bookID: '',
        dateTC: '',
        tcYear: '',
        tcMonth: '',
        tcDay: '',
        circles: [],
        CircleID: ''
    };
  },

 computed: {
    user(){
    return this.$store.state.user
  },
    profile(){
    return this.$store.state.profile
  },
    pageLength(){
        return this.$store.state.pageLength
    },

    loginState(){
    return this.$store.state.loginState
  },

  token(){
    return this.$store.state.token
  }

},

 created(){

 },

 mounted() {
    this.recordLast = this.pageLength;
      this.profileID = this.$route.params.profileID;
      this.getProfile(this.$route.params.profileID);
        this.getContent(1)
  },

  methods: {

    async getProfile() {
    await EventService.getProfileUser(this.profileID)
      .then(
        (profileUser => {
          this.$set(this, "profileUser", profileUser[0]);
        }).bind(this) )
        .then(() => {
          this.$store.dispatch('setProfile', this.profileUser);
        })
        .then(async () => {
          let sas = await EventService.getSASKey(this.$store.state.profile.UserMediaLoc);
          this.$set(this, "profilesas", sas);
        })
        },

  async  getContent(item) {
    this.recordStart = 0;
    this.recordLast = '';

switch(item) {
  case 'Memories':
    this.contentType = 1
    break;
  case 'Recipes':
    this.contentType = 3
    break;
  case 'Interviews':
    this.contentType = 2
    break;
  case 'Traditions':
    this.contentType = 4
    break;
  case 'Books':
    this.contentType = 'B'
    break;
  default:
    this.contentType = 1
}

  if(this.contentType === 1 || this.contentType === 2 || this.contentType === 3 || this.contentType == 4) {
    await EventService.getProfileMemories(this.user.UserID, this.profileID, this.contentType, this.recordStart, this.pageLength)
      .then(
        (memories => {
          this.$set(this, "memories", memories);
            this.$set(this, "recordLast", memories.output.recordCount)
            this.$set(this, "memories", memories.recordset);
        }).bind(this)

      );
  }
  else if (this.contentType === 'B') {
    await this.getProfileBookList();
  }
    },

    async getProfileBookList() {
      await EventService.getProfileBookList(this.user.UserID, this.profile.UserID)
      .then(
        (books => {
          this.$set(this, "books", books);
        }).bind(this)

      );
    },
  async  getMoreContent() {
 
  if(this.recordStart < this.recordLast || !this.recordLast ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.getProfileMemories(this.user.UserID, this.profileID, this.contentType, this.recordStart, this.pageLength)
      .then(
        (memories => {
            this.memories.push(...memories.recordset)
        }).bind(this)

      );
  }
  else if (this.contentType === 'B') {
    await this.getProfileBookList();
  }
    },

    handleScrolledToBottom(isVisible){

        if(!isVisible){
            return
        } else 
        {
        this.getMoreContent(this.contentType)
    }},


  }


}
</script>
<style lang="scss" scoped>


.photoBtn {
  margin-top: 1em;
  margin-bottom: 1em;
}

.story {
  min-height: 100%;
  background-color: white;
      margin-top: 2em;
    margin-left: 2em;

  margin-bottom: 1rem;
  margin-right: 5px;

  .storyDiv {
    justify-content: center;
  }
  .storySelector {
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 5px;
  }


}


</style>